import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { SubTabs } from 'shared/components';
import CUSTOMER_STATUS_QUERY, { CustomerStatusData } from 'shared/graphql/query/customerStatus';
import { CustomerStatus } from 'views/Setting/Routes/Customer/common/model/customerStatus.model';

interface CustomerTabProps {
  name: string;
  tab: CustomerStatus;
  onChange: (tab: CustomerStatus) => void;
}

const CustomerTab: React.FC<CustomerTabProps> = (props) => {
  const { tab, onChange, name } = props;
  const { data, refetch } = useQuery<CustomerStatusData>(CUSTOMER_STATUS_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const checkSelectTab = (id: CustomerStatus) => {
    return id === tab && name === 'customer';
  };

  const selectTab = (index: CustomerStatus) => {
    refetch();
    onChange(index);
  };

  const tabs = [
    {
      id: CustomerStatus.active,
      name: 'ตารางรายการบัญชีลูกหนี้',
      color: 'badge-grey',
      count: data?.customerStatus.active || 0,
      active: false,
      divider: false,
    },
  ].map((item) => ({
    id: item.id,
    name: item.name,
    // count: item.count,
    active: checkSelectTab(item.id),
    clicked: () => selectTab(item.id),
    badgeClassName: checkSelectTab(item.id) ? item.color : null,
    divider: item.divider,
  }));

  return <SubTabs tabs={tabs} />;
};

export default CustomerTab;
